import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AuthService {

  constructor(private http: HttpClient) {
  }

  login(email: string, password: string, teams_id?: number): Observable<any> {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/auth/login', {
      email: email,
      password: password,
      teams_id: teams_id
    });
  }

  loginFromToken(token: string): Observable<any> {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/auth/login-from-token', {
      token: token
    });
  }


}
